// extracted by mini-css-extract-plugin
export default {"container":"DroppableCanvas_container__B2cDl"};